module.exports = __webpack_public_path__ + "img/20191209_111640-1.03237d33.jpg";